import React, { useEffect, useState } from 'react';
import { Admin, Resource,useGetIdentity } from 'react-admin';

// import dataproviders
import authProvider from './providers/authprovider';
import dataProvider from './providers/data-provider';

// import layout
import { Dashboard } from './pages/dashboard';
import ThemeReducer from './reducer/ThemeReducer';

// import resources
import servers from './pages/servers';
import users from './pages/users'
import companies from './pages/companies'
import { Menu } from './layout';

const App = () => {

	return (
		<Admin
			title="Arbiter - Administration Panel"
			dataProvider={dataProvider}
			authProvider={authProvider}
			customReducers={{ theme: ThemeReducer }}
			dashboard={Dashboard}
			menu={Menu}
			disableTelemetry
		>
			<Resource name="servers" {...servers} />
			<Resource name="users" {...users} />
			<Resource name="company" {...companies} />
		</Admin>
	)
};

export default App;